import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Grid from '@material-ui/core/Grid';
import { Divider } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    spacer: {
        flex: '1 1 100%'
    },
    actions: {
        color: theme.palette.text.secondary
    },
    title: {
        flex: '0 0 auto'
    }
})

class EnhancedTableToolbar extends React.Component {

    _onChangeSearch = (e) =>{
        //console.log(e.target.value);
        let filtered = {}
        if (e.target.value) {
            //console.log(e.target.value);
            //console.log(this.props.data);
            filtered = this.props.data.filter((itm) => {
                let flag = false
                for (let field in itm) {
                    //console.log(itm[field]);
                    if (typeof itm[field] === 'string') {
                        flag = flag || itm[field].toLowerCase().includes(e.target.value.toLowerCase())
                    }
                }
                return flag
            });
        } else {
            filtered = this.props.data
        }
        
        console.log(filtered)
        this.props.searchCallBack(filtered)
        //this.setState({filtered: filtered})
    };

    render() {
        const { classes } = this.props

        const searchBar =
        (<div style={{ width: "60vw" }}>
            <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                    <SearchIcon />
                </Grid>
                <Grid item xs={10}>
                    <TextField id="input-with-icon-grid" label="Search..." fullWidth onChange={this._onChangeSearch}/>
                </Grid>
            </Grid>
            <Divider />
        </div>)

        return (
            <Toolbar>
                <div className={classes.title}>
                    {searchBar}
                </div>
                <div className={classes.spacer} />
            </Toolbar>
        )
    }
}

EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired
}

export default withStyles(toolbarStyles)(EnhancedTableToolbar)


// WEBPACK FOOTER //
// ./src/components/CSSComponent/searchBar.js